import { jsx } from "react/jsx-runtime";
import React from "react";
import classnames from "classnames";
import "./style.css";
import { getSelectionMessage } from "../../utils/editorUtils";
function Caret({
  charWidth,
  row,
  sequenceLength,
  caretPosition,
  isProtein,
  onClick,
  isDraggable,
  leftMargin = 0,
  onRightClick,
  style,
  selectionMessage,
  className = "",
  showAminoAcidUnitAsCodon
}) {
  if (row.start <= caretPosition && row.end + 1 >= caretPosition || row.end === sequenceLength - 1 && row.end < caretPosition) {
    const cursorEl = /* @__PURE__ */ jsx(
      "div",
      {
        onClick,
        onContextMenu: onRightClick ? (e) => {
          onRightClick(e);
        } : void 0,
        title: selectionMessage || getSelectionMessage({
          caretPosition,
          isProtein,
          sequenceLength,
          showAminoAcidUnitAsCodon
        }),
        className: classnames(
          {
            notClickable: !isDraggable
          },
          "veCaret",
          "veRowViewCaret",
          className
        ),
        style: {
          left: leftMargin + (caretPosition - row.start) * charWidth - 2,
          ...style
        }
      },
      caretPosition
    );
    return cursorEl;
  } else {
    return null;
  }
}
export default Caret;
